import {
  MasterDatasetRunStatus,
  MasterDatasetSourceType,
  MasterDatasetType,
} from '../reporting/master-dataset.model';

export enum LoadMasterDatasetRunsRequestKeys {
  reportDate = 'reportDate',
}

export interface LoadMasterDatasetRunsRequest {
  [LoadMasterDatasetRunsRequestKeys.reportDate]: string;
}

export interface LoadMasterDatasetRunsItem {
  runId: string;
  datasetType: MasterDatasetType;
  sourceType: MasterDatasetSourceType;
  reportDate: string;
  uploadActionId?: string | null;
  sourceFileName?: string | null;
  sourceFilePath?: string | null;
  sourceContentType?: string | null;
  sourceFileSize?: number | null;
  status: MasterDatasetRunStatus;
  processingErrorMessage?: string | null;
  recordsTotal?: number | null;
  recordsValid?: number | null;
  recordsInvalid?: number | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface LoadMasterDatasetRunsResponse {
  runs: LoadMasterDatasetRunsItem[];
}
